<template>
  <b-col>
    <b-row>
      <b-col cols="12">
        <div
          class="d-flex justify-content-between align-items-center pt-50 mb-2"
        >
          <div>
            <h2 class="font-weight-bolder m-0">
              Partes de horas
            </h2>
          </div>
          <!-- Icono de filtro -->
          <div
              v-if="!user && currentUser.roles[0].name !== 'operario'"
            class="d-flex align-items-center ml-2"
          >
            <span
              class="cursor-pointer"
              @click="toggleFilterSidebar"
            >
              <feather-icon
                icon="FilterIcon"
                size="20"
              />
            </span>
          </div>
        </div>
      </b-col>
      <b-col cols="12">
        <!-- Sidebar de filtros (componente reutilizable) -->
        <filter-sidebar
            v-if="!user && currentUser.roles[0].name !== 'operario'"
          v-model="showFilterSidebar"
          :has-active-filters="hasActiveFilters"
          :active-filters="computedActiveFilters"
          @apply-filters="handleSearch"
          @clear-filters="clearFilters"
          @remove-filter="removeActiveFilter"
        >
          <!-- Slot de filtros -->
          <template #filters>
            <b-form-group
              label="Búsqueda"
              label-for="search-input"
            >
            <b-input-group class="input-group">
              <b-input-group-prepend is-text>
                <feather-icon icon="SearchIcon" />
              </b-input-group-prepend>
              <b-form-input
                id="search-input"
                v-model="searchTerm"
                type="text"
                :placeholder="'Buscar por nombre, etc.'"
                @keydown.enter.native="handleSearch"
              />
            </b-input-group>
          </b-form-group>
          <b-form-group label-for="department-select">
            <label class="d-flex align-items-center">
              Filtro de fichaje por QR
              <span class="ml-1 align-middle" v-b-tooltip.hover title="Selecciona un departamento para ver los fichajes realizados con QR en ese área.">
                <feather-icon icon="InfoIcon" size="18" class="text-primary" />
              </span>
            </label>
            <BaseSelect
              v-model="department_id"
              :searchable="true"
              :clearable="true"
              :multiple="false"
              :httpBody="{
                client_id: currentClient ? currentClient.id : ''
              }"
              :resource="'/departments'"
              :placeholder="'Todos los departamentos'"
              @input="handleDepartmentChange"
            />
          </b-form-group>
          <b-form-group
            v-if="canModuleVacation"
            label="Situación"
            label-for="attendance-status-select"
          >
            <v-select
              id="attendance-status-select"
              v-model="attendanceStatusFilter"
              :options="['Trabajando', 'Vacaciones', 'Baja']"
              :clearable="true"
              :searchable="false"
              :multiple="true"
              placeholder="Todas las situaciones"
            />
          </b-form-group>
        </template>
        </filter-sidebar>
      </b-col>
      <b-col cols="12">
        <b-card no-body>
          <div
            class="px-1 pb-1 pt-1 d-flex align-items-center justify-content-between"
          >
            <div>
              <span
                :class="typeList == 'daily' ? 'btn btn-primary' : 'btn btn-light'"
                @click="typeList = 'daily'"
              >
                Diario
              </span>
              <span
                :class="typeList == 'monthly' ? 'btn btn-primary' : 'btn btn-light'"
                @click="typeList = 'monthly'"
              >
                Mensual
              </span>
            </div>
            <div class="px-2 align-items-center">
              <b-row>
                <month-picker-input
                  v-if="typeList == 'monthly'"
                  v-model="dateMontly"
                  :no-default="true"
                  lang="es"
                  :default-month="defaultMonth"
                  :default-year="defaultYear"
                  class="month-picker-partes"
                />
                <flat-pickr
                  v-if="typeList == 'daily'"
                  v-model="date"
                  name="date"
                  class="form-control"
                  placeholder="dd/mm/YYYY"
                />
              </b-row>
            </div>
          </div>
          <div
            v-if="typeList == 'monthly'"
            class="text-right"
          >
            <b-button
              v-if="!user && currentUser.roles[0].name !== 'operario'"
              variant="primary"
              class="mr-1"
              @click="clickGenerateMonthly()"
            >
              Generar informes
            </b-button>
          </div>
          <b-row class="mb-1 align-items-center">
            <b-col
              cols="12"
              md="4"
              class="d-flex align-items-center"
            />
          </b-row>
          <b-table
            hover
            responsive
            :items="items"
            :fields="columnsSet"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            class="table-white pt-1"
            @sort-changed="handleSortChanged"
          >
            <template #cell(status)="data">
              <b-badge :variant="statusJourneyDayVariants[data.item.status]">
                {{ statusJourneyDayText[data.item.status] }}
              </b-badge>
              <span
                v-if="data.item.day && data.item.day.update"
                v-b-tooltip.hover
                class="ml-1 cursor-pointer text-warning"
                title="Jornada modificada"
              >
                <feather-icon
                  icon="AlertTriangleIcon"
                  size="20"
                />
              </span>
            </template>
            <template #cell(name)="data">
              <div class="d-flex align-items-center">
                <b-avatar
                  variant="dark"
                  size="md"
                  :src="data.item.avatar"
                />
                <b-link
                  v-if="role != 'operario'"
                  :to="{ name: 'viewUser', params: { id: data.item.id } }"
                  class="link"
                >
                  <span class="ml-1">{{ data.item.name }}</span>
                </b-link>
                <span v-else>
                  <span class="ml-1">{{ data.item.name }}</span>
                </span>
              </div>
            </template>
            <template #cell(attendance_status)="data">
              <b-badge
                v-if="data.item.attendance_status"
                pill
                :variant="attendanceStatusVariant(data.item.attendance_status)"
              >
                <feather-icon
                  :icon="attendanceStatusIcon(data.item.attendance_status)"
                  size="12"
                  class="mr-25"
                />
                {{ data.item.attendance_status }}
              </b-badge>
              <span v-else class="text-muted">—</span>
            </template>
            <template #cell(day.hour_ini)="data">
              {{ TimestampToFlatPickrOnlyTime(data.item.day.hour_ini) }}
              <span
                v-if="data.item.day && data.item.day.department && data.item.day.department.id"
                class=""
              >
                <img
                  v-b-tooltip.hover
                  src="/img/qr-code-solid.svg"
                  alt="QR Code Icon"
                  :title="data.item.day.department ? data.item.day.department.name : ''"
                >
              </span>
              <span
                v-if="data.item.day && data.item.day.reason_check_in"
                v-b-tooltip.hover
                class="ml-0_5 cursor-pointer text-danger"
                :title="`Motivo inicio tardío: ${data.item.day.reason_check_in}`"
              >
                <feather-icon
                  icon="ClockIcon"
                  size="20"
                />
              </span>
            </template>
            <template #cell(day.hour_fin)="data">
              {{ TimestampToFlatPickrOnlyTime(data.item.day.hour_fin) }}
              <span
                v-if="data.item.day && data.item.day.department_out && data.item.day.department_out.id"
                class=""
              >
                <img
                  v-b-tooltip.hover
                  src="/img/qr-code-solid.svg"
                  alt="QR Code Icon"
                  :title="data.item.day.department_out ? data.item.day.department_out.name : ''"
                >
              </span>
              <span
                v-if="data.item.day && data.item.day.reason_check_out"
                v-b-tooltip.hover
                class="ml-0_5 cursor-pointer text-danger"
                :title="`Motivo salida tardía: ${data.item.day.reason_check_out}`"
              >
                <feather-icon
                  icon="ClockIcon"
                  size="20"
                />
              </span>
            </template>
            <template #cell(hours)="data">
              <span v-if="typeList == 'daily'">{{
                data.item.total_horas_day
              }}</span>
              <span v-if="typeList == 'monthly'">{{
                data.item.month.horas_imputadas
              }}</span>
            </template>
            <template #cell(actions)="data">
              <span>
                <private-pdf-download
                  v-if="typeList == 'monthly' && data.item.pdf_month"
                  :pdf-url="urlExcelMonth(data.item.id)"
                  :file-name="`jornada_mensual_excel_${data.item.name}.xlsx`"
                  icon="PrinterIcon"
                />
                <private-pdf-download
                  v-if="typeList == 'daily' && data.item.pdf_day"
                  :pdf-url="urlExcelDay(data.item.id)"
                  :file-name="`jornada_diaria_excel_${data.item.name}.xlsx`"
                  icon="PrinterIcon"
                />
                <private-pdf-download
                  v-if="typeList == 'daily' && data.item.pdf_day"
                  :pdf-url="data.item.pdf_day"
                  :file-name="`jornada_diaria_${data.item.name}.pdf`"
                  icon="DownloadIcon"
                />
                <private-pdf-download
                  v-if="typeList == 'monthly' && data.item.pdf_month"
                  :pdf-url="data.item.pdf_month"
                  :file-name="`jornada_mensual_${data.item.name}.pdf`"
                  icon="DownloadIcon"
                />

                <a
                  v-if="typeList == 'daily' && role !== 'operario'"
                  class="d-inline-block px-50 text-dark"
                  @click="showModal(data.item)"
                >
                  <feather-icon icon="Edit2Icon" />
                </a>
              </span>
            </template>
          </b-table>
          <div
            v-if="!user && (totalItems / pageLength) > 1"
            class="d-flex align-items-center justify-content-between mb-1 px-2"
          >
            <div class="d-flex align-items-center mb-0">
              <span class="text-nowrap"> {{ "Por página" }}: </span>
              <b-form-select
                v-model="pageLength"
                :options="pages"
                class="ml-50 mr-1"
                @input="handlePageChange"
              />
              <span class="text-nowrap"> {{ "Total" }}: {{ totalItems }}</span>
            </div>
            <div>
              <b-pagination
                v-model="currentPage"
                :total-rows="totalItems"
                :per-page="pageLength"
                first-number
                last-number
                align="right"
                prev-class="prev-item"
                next-class="next-item"
                class="mt-1 mb-0"
                @change="handleChangePage"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <b-modal
      id="cambiar-jornada"
      v-model="modalShow"
      :title="'Editar jornada '+user_name"
      size="md"
      hide-footer
    >
      <validation-observer ref="updateJourneyDay">
        <b-form
          @submit.prevent="handleSubmit"
          @keydown.enter="handleSubmit"
        >
          <b-row class="d-flex justify-content-center">
            <b-col
              v-for="(day, index) in days"
              :key="index"
              sm="12"
            >
              <b-row>
                <b-col lg="6">
                  <validation-provider
                    #default="{ errors }"
                    :name="`Entrada ${index + 1}`"
                    rules="required"
                  >
                    <b-form-group
                      :label="`Entrada ${index + 1}`"
                      :label-for="`task-fechaini-${index}`"
                    >
                      <b-form-timepicker
                        v-model="day.hour_ini"
                        locale="es"
                      />
                    </b-form-group>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-col>
                <b-col lg="6">
                  <b-form-group
                    :label="`Salida ${index + 1}`"
                    :label-for="`task-fechafin-${index}`"
                  >
                    <b-form-timepicker
                      v-model="day.hour_fin"
                      :locale="locale"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  v-if="index === days.length - 1"
                  sm="12"
                >
                  <validation-provider
                    #default="{ errors }"
                    :name="'Estado'"
                    rules="required"
                  >
                    <b-form-group
                      :label="'Estado'"
                      label-for="task-status"
                    >
                      <v-select
                        v-model="status"
                        :filterable="false"
                        :searchable="false"
                        :options="selectStatus"
                        :placeholder="'Estado'"
                      >
                        <template
                          slot="option"
                          slot-scope="option"
                        >
                          {{ statusJourneyDayText[option.label] }}
                        </template>
                        <template
                          slot="selected-option"
                          slot-scope="option"
                        >
                          {{ statusJourneyDayText[option.label] }}
                        </template>
                      </v-select>
                    </b-form-group>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-col>
              </b-row>
            </b-col>
            <b-col
              sm="12"
            >
              <validation-provider
                #default="{ errors }"
                :name="'Motivo del cambio'"
                rules="required"
              >
                <b-form-group
                  :label="'Motivo del cambio'"
                  label-for="task-motivo"
                >
                  <b-form-textarea
                    v-model="motivo"
                    placeholder="Escribe el motivo del cambio"
                    rows="3"
                    max-rows="6"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col
              cols="12"
              class="text-right"
            >
              <b-button
                type="submit"
                variant="primary"
                class="mt-2 mr-1"
              >
                {{ "Guardar" }}
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-modal>
  </b-col>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import {
  BAvatar,
  BBadge,
  BPagination,
  BFormInput,
  BFormSelect,
  BCard,
  BTable,
  BButton,
  BCol,
  BRow,
  BLink,
  BInputGroup,
  BInputGroupPrepend,
  BFormTimepicker,
  BFormGroup,
  BForm,
  BFormTextarea,
  VBTooltip,
} from 'bootstrap-vue'
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'
import flatPickr from 'vue-flatpickr-component'
import {
  FlatPickrToTimestamp,
  TimestampToFlatPickrOnlyTime,
  FlatPickrToTimestampWithTime,
} from '@/libs/helpers'
import { MonthPickerInput } from 'vue-month-picker'
import { config } from '@/shared/app.config'
import vSelect from 'vue-select'
import PrivatePdfDownload from '@/components/ui/PrivatePdfDownload.vue'
import BaseSelect from '@/components/ui/select/BaseSelect.vue'
import FilterSidebar from '@/components/ui/FilterSidebar.vue'

export default {
  components: {
    BBadge,
    BAvatar,
    BCard,
    BTable,
    BButton,
    BPagination,
    BCol,
    BRow,
    BLink,
    BFormInput,
    BFormSelect,
    BInputGroup,
    BInputGroupPrepend,
    flatPickr,
    MonthPickerInput,
    BFormTimepicker,
    BFormGroup,
    BForm,
    vSelect,
    BFormTextarea,
    PrivatePdfDownload,
    BaseSelect,
    FilterSidebar,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  props: {
    user: {
      type: Object,
    },
  },
  data() {
    let date = ''
    const d = new Date()
    date = `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()}`
    const defaultMonth = d.getMonth() + 1
    const defaultYear = d.getFullYear()
    const className = this.user ? 'd-none' : ''
    return {
      statusJourneyDayVariants: config.statusJourneyDayVariants,
      statusJourneyDayText: config.statusJourneyDayText,
      log: [],
      currentPage: 1,
      userSelect: '',
      defaultMonth,
      defaultYear,
      pageLength: 25,
      typeList: 'daily',
      dateMontly: '',
      dir: false,
      motivo: '',
      hour_ini: '',
      hour_fin: '',
      hour_extra: '',
      status: '',
      user_id: '',
      user_name: '',
      modalShow: false,
      days: '',
      date,
      timestampDateMonthly: '',
      pages: ['25', '50', '100'],
      department_id: '',
      showFilterSidebar: false,
      appliedSearchTerm: '',
      appliedDepartmentId: null,
      attendanceStatusFilter: [],
      appliedAttendanceStatus: [],
      locale: 'es',
      labels: {
        es: {
          labelHours: 'Stunden',
          labelMinutes: 'Minuten',
          labelSeconds: 'Sekunden',
          labelIncrement: 'Erhöhen',
          labelDecrement: 'Verringern',
          labelSelected: 'Ausgewählte Zeit',
          labelNoTimeSelected: 'Keine Zeit ausgewählt',
          labelCloseButton: 'Schließen',
        },
      },
      sortBy: '',
      sortDesc: false,
      columns: [
        {
          label: 'Operario',
          key: 'name',
          class: className,
          sortable: true,
        },
        {
          label: 'Estado',
          key: 'status',
        },
        {
          label: 'Situación',
          key: 'attendance_status',
        },
        {
          label: 'Entrada',
          key: 'day.hour_ini',
        },
        {
          label: 'Salida',
          key: 'day.hour_fin',
        },
        {
          label: 'TRABAJADAS',
          key: 'total_horas_day',
        },
        {
          label: 'Acciones',
          key: 'actions',
          class: 'column-actions',
        },
      ],
      columnsMonthly: [
        {
          label: 'Operario',
          key: 'name',
          class: className,
          sortable: true,
        },
        {
          label: 'TRABAJADAS',
          key: 'month.horas_trabajadas',
        },
        {
          label: 'Acciones',
          key: 'actions',
          class: 'column-actions',
        },
      ],
      searchTerm: '',
    }
  },
  watch: {
    chargeList() {
      if (this.chargeList === 1) {
        this.chargeData()
        this.modalShow = false
      }
    },
    date() {
      this.chargeData()
    },
    dateMontly() {
      this.chargeData()
    },
    typeList() {
      this.chargeData()
    },
  },
  computed: {
    ...mapGetters({
      currentUser: 'auth/getUser',
      items: 'partes/getItems',
      totalItems: 'partes/getTotalItems',
      chargeList: 'partes/getChargeList',
      selectStatus: 'partes/getSelectStatus',
      currentClient: 'clients/getCurrentClient',
      role: 'auth/getRole',
      canModuleVacation: 'clients/getCanEditModuleVacations',
    }),
    columnsSet() {
      if (this.typeList === 'monthly') {
        return this.columnsMonthly
      }
      if (!this.canModuleVacation) {
        return this.columns.filter(c => c.key !== 'attendance_status')
      } else {
        return this.columns.filter(c => c.key !== 'status')
      }
      return this.columns
    },
    hasActiveFilters() {
      return this.appliedSearchTerm !== '' || this.appliedDepartmentId !== null || this.appliedAttendanceStatus.length > 0
    },
    computedActiveFilters() {
      const filters = []
      if (this.appliedSearchTerm) {
        filters.push({
          label: 'Búsqueda',
          value: this.appliedSearchTerm,
          icon: 'SearchIcon',
          filterType: 'search',
        })
      }
      if (this.appliedDepartmentId) {
        filters.push({
          label: 'Departamento',
          value: this.appliedDepartmentId.name,
          icon: 'LayersIcon',
          filterType: 'department',
        })
      }
      if (this.appliedAttendanceStatus.length > 0) {
        filters.push({
          label: 'Situación',
          value: this.appliedAttendanceStatus.join(', '),
          icon: 'BriefcaseIcon',
          filterType: 'attendance',
        })
      }
      return filters
    },
  },
  created() {
    this.chargeData()
  },
  methods: {
    ...mapActions({
      list: 'partes/getList',
      generateMonthly: 'partes/generateMonthly',
      edit: 'partes/edit',
      getSelectStatus: 'partes/getSelectStatus',
    }),
    ...mapMutations({
      setChargeList: 'partes/setChargeList',
    }),
    async showModal(item) {
      this.motivo = ''
      this.status = item.status
      this.user_id = item.id
      this.user_name = item.name
      this.days = item.days.map(d => ({
        ...d,
        hour_ini: this.TimestampToFlatPickrOnlyTime(d.hour_ini),
        hour_fin: this.TimestampToFlatPickrOnlyTime(d.hour_fin),
      }))
      this.modalShow = true
      await this.getSelectStatus()
    },
    async chargeData() {
      let timestamp = FlatPickrToTimestamp(this.date)

      if (this.typeList === 'monthly') {
        if (this.dateMontly === '') {
          timestamp = FlatPickrToTimestamp(
            `01/${this.defaultMonth}/${this.defaultYear}`,
          )
        } else {
          const d = this.dateMontly.from
          const date = `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()}`
          timestamp = FlatPickrToTimestamp(date)
        }
        this.timestampDateMonthly = timestamp
      }
      let userId = ''
      if (this.user) {
        userId = this.user.id
      }
      let clientId = ''
      if (this.currentClient) {
        clientId = this.currentClient.id
      }
      // Mapeo de columnas para orderBy
      let orderBy = ''
      if (this.sortBy) {
        const type = this.sortDesc ? 'desc' : 'asc'
        // Mapeo de keys de la tabla a columnas de la API
        const columnMap = {
          name: 'name', // nombre del operario
          status: 'status',
          'day.hour_ini': 'hour_ini',
          'day.hour_fin': 'hour_fin',
          total_horas_day: 'total_horas_day',
          'month.horas_trabajadas': 'total_horas_day', // para mensual
        }
        const column = columnMap[this.sortBy] || this.sortBy
        orderBy = {
          column,
          type,
        }
      }
      this.list({
        page: this.currentPage,
        per_page: this.pageLength,
        search: this.searchTerm,
        timestamp,
        user: userId,
        client: clientId,
        department_id: this.department_id ? this.department_id.id : '',
        attendance_status: this.attendanceStatusFilter.length > 0 ? this.attendanceStatusFilter : '',
        orderBy,
      })
      this.setChargeList(0)
    },
    handleSearch() {
      this.currentPage = 1
      this.appliedSearchTerm = this.searchTerm
      this.appliedDepartmentId = this.department_id
      this.appliedAttendanceStatus = this.attendanceStatusFilter
      this.chargeData()
    },
    clearFilters() {
      this.searchTerm = ''
      this.department_id = null
      this.attendanceStatusFilter = []
      this.appliedSearchTerm = ''
      this.appliedDepartmentId = null
      this.appliedAttendanceStatus = []
      this.currentPage = 1
      this.chargeData()
    },
    removeActiveFilter(idx) {
      const f = this.computedActiveFilters[idx]
      if (f && f.filterType === 'search') {
        this.appliedSearchTerm = ''
        this.searchTerm = ''
      } else if (f && f.filterType === 'department') {
        this.appliedDepartmentId = null
        this.department_id = null
      } else if (f && f.filterType === 'attendance') {
        this.appliedAttendanceStatus = []
        this.attendanceStatusFilter = []
      }
      this.currentPage = 1
      this.chargeData()
    },
    handleChangePage(page) {
      this.currentPage = page
      this.chargeData()
    },
    handlePageChange() {
      this.currentPage = 1
      this.chargeData()
    },
    TimestampToFlatPickrOnlyTime(f) {
      return TimestampToFlatPickrOnlyTime(f)
    },
    FlatPickrToTimestampWithTime(f) {
      return FlatPickrToTimestampWithTime(f)
    },
    async actionGenerateMonthly() {
      let timestamp = FlatPickrToTimestamp(this.date)
      if (this.typeList === 'monthly') {
        if (this.dateMontly === '') {
          timestamp = FlatPickrToTimestamp(
            `01/${this.defaultMonth}/${this.defaultYear}`,
          )
        } else {
          const d = this.dateMontly.from
          const date = `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()}`
          timestamp = FlatPickrToTimestamp(date)
        }
      }
      await this.generateMonthly({ timestamp, client_id: this.currentClient.id })
    },
    urlExcelDay(user) {
      return `${
        config.webApiBase
      }/journeyday/export/day/${user}/${FlatPickrToTimestamp(this.date)}`
    },
    urlExcelMonth(user) {
      return `${config.webApiBase}/journeyday/export/monthly/${user}/${this.timestampDateMonthly}`
    },
    async clickGenerateMonthly() {
      await this.actionGenerateMonthly()
      await this.chargeData()
    },
    handleSubmit() {
      this.$refs.updateJourneyDay.validate().then(success => {
        if (success) {
          const formData = this.createFormData()
          if (formData) {
            this.edit({ user: formData })
          }
        }
      })
    },
    createFormData() {
      const data = new FormData()
      const newStatus = this.status && this.status.label ? this.status.label : this.status
      const daysWithStatus = this.days.map(d => ({ ...d, status: newStatus }))
      data.append('days', JSON.stringify(daysWithStatus))
      data.append('motivo', this.motivo)
      data.append('day', this.FlatPickrToTimestampWithTime(this.date))
      data.append('user_id', this.user_id)

      return data
    },
    handleDepartmentChange() {
      this.currentPage = 1
    },
    toggleFilterSidebar() {
      this.showFilterSidebar = !this.showFilterSidebar
    },
    handleSortChanged(ctx) {
      this.sortBy = ctx.sortBy
      this.sortDesc = ctx.sortDesc
      this.chargeData()
    },
    attendanceStatusVariant(status) {
      const map = {
        Trabajando: 'secondary',
        Vacaciones: 'warning',
        Baja: 'danger',
      }
      return map[status] || 'secondary'
    },
    attendanceStatusIcon(status) {
      const map = {
        Trabajando: 'BriefcaseIcon',
        Vacaciones: 'SunIcon',
        Baja: 'ThermometerIcon',
      }
      return map[status] || 'CircleIcon'
    },
  },
}
</script>
<style lang="scss">
@import "@core/scss/vue/bootstrap-vue/index.scss";
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
.month-picker--default{
  z-index: 1;
}
</style>
